import * as React from 'react';
import { useTheme } from '../../theme';
import { default as BaseButton } from '../../BaseComponents/Button';
import Modal from '../../Modal';
import cn from 'classnames';
import { ClassNameMap, DialogClassKey } from '@mui/material';
import { useIsMobile } from '../../utils';
import { SafeHtml } from '@shared/ui';

interface Props {
	title?: string;
	content: string | React.ReactNode;
	errorMessage?: string | React.ReactNode;
	buttonText?: string;
	buttonCloseText?: string;
	isOpen?: boolean;
	onClose?: () => void;
	onButtonClick?: () => void;
	className?: string;
	classes?: Partial<ClassNameMap<DialogClassKey>>;
	hideContentText?: boolean;
	bottomDrawer?: boolean;
}

const WarningModal: React.FC<Props> = ({
	title,
	content,
	className,
	classes,
	errorMessage,
	buttonText,
	buttonCloseText,
	isOpen,
	hideContentText,
	bottomDrawer,
	onClose,
	onButtonClick
}) => {
	const { WarningModal: css } = useTheme('WarningModal');

	const isMobile = useIsMobile();

	return (
		<Modal
			maxWidth="sm"
			closeClassName={css.closeButton}
			open={isOpen}
			onClose={onClose}
			isRounded={bottomDrawer}
			classes={{
				...classes,
				scrollBody: cn(css.scrollBody, classes?.scrollBody),
				paper: cn(css.paper, className, classes?.paper)
			}}
			slideUp={isMobile}
			bottomDrawer={bottomDrawer}
		>
			{title && <div className={css.header}>{title}</div>}

			<div className={css.content}>
				<div className={cn(css.content__text, { [css.content__text_hidden]: hideContentText })}>
					{typeof content === 'string' ? <SafeHtml tag="div" html={content} /> : <div>{content}</div>}
				</div>

				{errorMessage && typeof errorMessage === 'string' && (
					<SafeHtml tag="div" className={css.content__error} html={errorMessage} />
				)}
				{errorMessage && typeof errorMessage !== 'string' && (
					<div className={css.content__error}>{errorMessage}</div>
				)}

				{buttonText && (
					<div className={css.buttons}>
						<BaseButton variant="optionAction" onClick={onButtonClick}>
							{buttonText}
						</BaseButton>

						{buttonCloseText && (
							<BaseButton variant="optionEdit" onClick={onClose}>
								{buttonCloseText}
							</BaseButton>
						)}
					</div>
				)}
			</div>
		</Modal>
	);
};

export default WarningModal;
